
<template>
  <zj-layout-container>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="16rem"
      :disabled="editable"
    >
      <el-row>
        <el-form-item
          label="上报单位"
          style="display: inline-block"
          prop="reportDept"
        >
          <el-cascader
            :options="OrgOptions"
            :props="OrgoptionsProps"
            :show-all-levels="false"
            @change="handleChange"
            v-model="reportDept"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="上报人员"
          prop="reportPerson"
          style="display: inline-block"
        >
          <el-input v-model="ruleForm.reportPerson"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="上报时间"
          prop="reportTime"
          style="display: inline-block"
        >
          <el-date-picker
            placeholder="选择日期"
            type="datetime"
            v-model="ruleForm.reportTime"
            format="yyyy-MM-dd HH:mm:ss" 
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="上报内容"
          prop="reportContent"
          style="display: inline-block"
        >
          <el-input type="textarea" v-model="ruleForm.reportContent"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="上报单位指示"
          prop="instructions"
          style="display: inline-block"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.instructions"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="上报方式"
          prop="reportMode"
          style="display: inline-block"
        ></el-form-item>
        <el-checkbox-group
          @change="handleCheckedChange"
          v-model="reportMode"
          style="display: inline-block; position: absolute; line-height: 4rem"
        >
          <el-checkbox
            v-for="item in reportModeOptions"
            :key="item.code"
            :label="item.code"
            :value="item.code"
            >{{ item.value }}</el-checkbox
          >
        </el-checkbox-group>
      </el-row>
    </el-form>
  </zj-layout-container>
</template>
<script>
import ZJApp from "../../../../../app";
import ZJApis from "../../../../../../api";
import permissionsApi from "../../../../../../request/permissionsApi";
import utils from "../../../../../../utils";
import { deptTreeData } from "@/api/system/permission/dept";
import { getDictionary } from "@/api/src/emergency_common";

import dayjs from 'dayjs'

export default {
  name: "ZjReportEventTable",
  controller: "UI",
  action: "ReportEventTable",
  props: {
    reportObj: Object,
    editable: { type: Boolean, default: false },
  },
  data() {
    return {
      reportModeOptions: [],
      reportMode: [],
      OrgOptions: [],
      OrgoptionsProps: {
        value: "id",
        label: "label",
        children: "children",
        checkStrictly: true,
        emitPath: false,
      },
      valid: "fail",
      reportDept: [""],
      ruleForm: {
        eventId: "",
        reportPerson: "",
        reportDept: "",
        reportContent: "",
        instructions: "",
        reportTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        reportMode: "",
        Validity: 1,
      },
      rules: {
        reportDept: [{ required: true, message: "请选择上报单位" }],
        reportPerson: [{ required: true, message: "请输入上报人员" }],
        reportContent: [{ required: true, message: "请输入上报内容" }],
      },
    };
  },
  created: function () {
    if (this.CNF("app.isBiaoZhunHua")) {
      const that = this;
      permissionsApi
        .findBySysCode({
          projectCode: this.CNF("app.perProjectCode"),
          organizationCode: that.zj_user.userInfo.organization[0].code || "",
          type: "景区",
        })
        .then((res) => {
          if (res.code == 0) {
            let orgArr = utils.flattenArray(JSON.parse(res.data.data));
            const departs = orgArr.map((item) => {
              return {
                Id: item.id,
                OrgId: item.code,
                OrgName: item.name,
                Description: item.description,
                CreateTime: item.createdate,
                Creater: item.creater,
                ModifyTime: item.modifydate,
                Modifier: item.modefier,
                ParentOrgId: item.perOrganizationCode || "",
              };
            });
            let orgs = this.convertToTreeNodes(departs);
            if (orgs) {
              // setIsLeaf() 函数：当无下级组织时，删除 'OrgInfos' 字段。
              const setIsLeaf = function (items) {
                if (items && items.length > 0) {
                  items.forEach((x) => {
                    x.IsLeaf = x && x.OrgInfos && x.OrgInfos.length == 0;
                    if (!x.IsLeaf) {
                      setIsLeaf(x.OrgInfos);
                    } else {
                      delete x["OrgInfos"];
                    }
                  });
                }
              };
              setIsLeaf(orgs);
              this.OrgOptions = orgs;
              if (this.reportObj) {
                var item = this.GetDeptInfo(
                  this.OrgOptions,
                  this.reportObj.reportDept
                );
                if (item) {
                  // this.reportDept = item.OrgTiers.split(";");
                  var reportdept = item.OrgTiers.split(";");
                  var reportComdep = [];
                  for (var i = 0; i < reportdept.length; i++) {
                    var retitme = this.GetDeptInfo(
                      this.OrgOptions,
                      reportdept[i]
                    );
                    if (retitme) {
                      reportComdep.push(reportdept[i]);
                    }
                  }
                  this.reportDept = reportComdep;
                  // console.log( this.reportDept);
                }
              }
            }
          } else {
            this.$message({
              type: "success",
              message: res.msg
            });
          }
        });
    } else {
      this.getTreeselect();
      // new ZJApis.OrgApi()
      //   .GetOrgTiers({
      //     OrgId:
      //       ZJApp.ZJUser.current.Departments.length > 0
      //         ? ZJApp.ZJUser.current.Departments[0].OrgId
      //         : "error-no-department"
      //   })
      //   .then(r => {
      //     var orgs = r.data.Data;
      //     if (orgs) {
      //       // setIsLeaf() 函数：当无下级组织时，删除 'OrgInfos' 字段。
      //       const setIsLeaf = function(items) {
      //         if (items && items.length > 0) {
      //           items.forEach(x => {
      //             x.IsLeaf = x && x.OrgInfos && x.OrgInfos.length == 0;
      //             if (!x.IsLeaf) {
      //               setIsLeaf(x.OrgInfos);
      //             } else {
      //               delete x["OrgInfos"];
      //             }
      //           });
      //         }
      //       };
      //       setIsLeaf(orgs);
      //       this.OrgOptions = orgs;
      //       if (this.reportObj) {
      //         var item = this.GetDeptInfo(
      //           this.OrgOptions,
      //           this.reportObj.reportDept
      //         );
      //         if (item) {
      //           // this.reportDept = item.OrgTiers.split(";");
      //           var reportdept = item.OrgTiers.split(";");
      //           var reportComdep = [];
      //           for (var i = 0; i < reportdept.length; i++) {
      //             var retitme = this.GetDeptInfo(
      //               this.OrgOptions,
      //               reportdept[i]
      //             );
      //             if (retitme) {
      //               reportComdep.push(reportdept[i]);
      //             }
      //           }
      //           this.reportDept = reportComdep;
      //           // console.log( this.reportDept);
      //         }
      //       }
      //     }
      //   })
      //   .catch(e => {
      //     console.log(e);
      // this.$message({
      //     type: "error",
      //     message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！"
      //   });
      //   });
    }

    if (this.reportObj) {
      this.ruleForm = this.reportObj;
      this.reportMode = this.ruleForm.reportMode.split(",");
      this.reportDept = this.reportObj.reportDept.toString();
    }
    getDictionary('emergency_report_mode')
      .then((reportwayconf) => {
        this.reportModeOptions = reportwayconf.data.records;
      })
      .catch((e) => {
        console.log(e);
      });
  },
  methods: {
    // 查询部门下拉树结构
    getTreeselect() {
      deptTreeData().then((response) => {
        this.OrgOptions = response.data;
      });
    },
    handleCheckedChange(value) {
      this.reportMode = value;
      this.ruleForm.reportMode = value.join(",");
    },
    handleChange(value) {
      this.ruleForm.reportDept = value;
      // var item = this.GetDeptInfo(this.OrgOptions, value);
      // if (item) {
      //   this.ruleForm.ReportCompanyName = item.label;
      // }
    },
    GetDeptInfo(depts, deptid) {
      if (!depts) return undefined;
      for (var i = 0; i < depts.length; i++) {
        var item = depts[i];
        if (item.id == deptid) {
          return item;
        } else {
          var ret = this.GetDeptInfo(item.children, deptid);
          if (ret) {
            return ret;
          }
        }
      }
    },
    GetValidate() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (
            this.ruleForm.reportDept &&
            this.ruleForm.reportDept != ""
          ) {
            this.valid = "ok";
          } else {
            this.$message({
              type: "error",
              message: "请选择上报部门"
            });
            this.valid = "fail";
          }
        } else {
          this.valid = "fail";
        }
      });
    },
    convertToTreeNodes(dataList) {
      let formatObj = dataList.reduce((pre, cur) => {
        return { ...pre, [cur["OrgId"]]: cur };
      }, {});

      let formatArray = dataList.reduce((arr, cur) => {
        let ParentOrgId = cur.ParentOrgId ? cur.ParentOrgId : 0;
        let parent = formatObj[ParentOrgId];
        if (parent) {
          parent.OrgInfos
            ? parent.OrgInfos.push(cur)
            : (parent.OrgInfos = [cur]);
        } else {
          arr.push(cur);
        }
        return arr;
      }, []);
      return formatArray;
      // this.convertToTreeNodesfunction(formatArray);
    },
  },
};
</script>